import { render, staticRenderFns } from "./StatsSaleTotal.vue?vue&type=template&id=e29074f0&"
import script from "./StatsSaleTotal.vue?vue&type=script&lang=js&"
export * from "./StatsSaleTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports